var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modify-detail-property-overview" }, [
    _c("div", { staticClass: "modify-detail-property-overview__wrapper" }, [
      _c("div", { staticClass: "modify-detail-property-overview__content" }, [
        _c("div", { staticClass: "property-name" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.currentReservationData.property.name) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-address" }, [
          _c("div", { staticClass: "street" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.currentReservationData.property.address) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "locale" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.currentReservationData.property.city) + ","),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "country" }, [
              _vm._v(_vm._s(_vm.currentReservationData.property.country)),
            ]),
            _c("span", { staticClass: "postal" }, [
              _vm._v(_vm._s(_vm.currentReservationData.property.postalCode)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-phone" }, [
          _vm._m(0),
          _vm._v(
            "\n        " +
              _vm._s(_vm.currentReservationData.property.phone) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-email" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "mailto:" + _vm.currentReservationData.property.email,
              },
            },
            [_vm._v(_vm._s(_vm.currentReservationData.property.email))]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modify-detail-property-overview__map" }, [
        _c(
          "div",
          { staticClass: "map-frame map google-map component" },
          [
            _c("google-map", {
              attrs: {
                properties: [
                  {
                    Title: "" + _vm.currentReservationData.property.name,
                    Image: "" + _vm.currentReservationData.property.image,
                    ImageAlt: "" + _vm.currentReservationData.property.imageAlt,
                    Link: "" + _vm.currentReservationData.property.link,
                    Latitude: "" + _vm.currentReservationData.property.latitude,
                    Longitude:
                      "" + _vm.currentReservationData.property.longitude,
                  },
                ],
                options: {
                  MapType: "default-map",
                  ApiKey:
                    "" + _vm.modifyBookingPropData.ModifyReservationMapAPIKey,
                  Latitude: "" + _vm.currentReservationData.property.latitude,
                  Longitude: "" + _vm.currentReservationData.property.longitude,
                  ZoomLevel: 12,
                  CtaButtonTitle: "Get Directions",
                  MapId:
                    "" + _vm.modifyBookingPropData.ModifyReservationGoogleMapId,
                  MarkerColor:
                    "" +
                    _vm.modifyBookingPropData
                      .ModifyReservationGoogleMarkerColor,
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "property-icon" }, [
      _c("span", { staticClass: "icon-phone-white" }),
      _c("span", { staticClass: "icon-phone print-only" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "property-icon" }, [
      _c("span", { staticClass: "icon-envelope-white" }),
      _c("span", { staticClass: "icon-envelope print-only" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }